<template>
  <div>
      <ejs-tab ref='tabObj' heightAdjustMode='heightAdjustMode' cssClass='tabsClass' :selectedItem="selectedItem">
        <div class="e-tab-header h-subscriber-subTabs-header">
          <div v-for="item of headers" :key="item.key">{{item.text}}</div>
        </div>
        <div class="e-content h-subscriber-subTabs-content">
          <div id='deployedService'>
            <div class="row h-row-inputBox">
              <div class="col-sm-12 h-col-inputBox">
                <div class="form-group">
                  <div class="e-float-input">
                    <div class="h-inputLit" style="float:left;line-height: 40px;float: left;font-size: 18px;text-indent: 5px;color: #1890ff;">{{this.$t('DeployManagement.deployedInstanceCount')}}: {{deployedInstanceCount}}</div>
                  </div>
                  <div class="error" style="float:left;line-height: 40px;float: left;font-size: 18px;text-indent: 5px;color: #1890ff;">{{this.$t('DeployManagement.failedInstanceName')}}: {{failedInstanceName}}</div>
                </div>
              </div>

            </div>
            <Table ref="deployedServiceData" :qryParam="qryParam"></Table>
          </div>
          <div id='deployedNode'>
            <div class='h-toolbarBg'>
              <ejs-toolbar>
                <div>
                  <div>
                    <button :title='$t("MCS.addUser")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("add")' data-ripple="true" tabindex="-1" style="width: auto;">
                      <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
                    </button>
                  </div>
                  <!--<div>
                    <button :title='$t("MCS.mod")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("edit")' data-ripple="true" tabindex="-1" style="width: auto;">
                      <span class="e-btn-icon icon hero-icon hero-icon-edit e-icons"></span>
                    </button>
                  </div>-->
                  <div>
                    <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("del")' data-ripple="true" tabindex="-1" style="width: auto;">
                      <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                    </button>
                  </div>
                </div>
              </ejs-toolbar>
            </div>
            <Table ref="deployedNodeData" :qryParam="qryParam" rowSelectedflag="true"></Table>
          </div>
        </div>
      </ejs-tab>
      <CustomDialog ref='addDPNodePage' :element='dialog.element.eleAddDpNode' :styles='dialog.styles' :messages='dialog.messages.addDpNode'>
        <template v-slot:dialog-content>
          <AddDPNode ref='addDPNodeDialog'></AddDPNode>
        </template>
      </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../../../../common/CustomDialog';
import Table from '../../../serverManagement/Table';
import AddDPNode from './AddDPNode';
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: 'DPInstanceDetail',
  data() {
    return {
      dialog: {
        styles: {
          width: '45%',
          height: '60%',
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          eleAddDpNode: {
            target: this.$refs.grid,
            refName: 'eleAddDpNode',
            buttonGroup: [
              {click: this.closeDPNodePage, buttonModel: {content: this.$t('UE.ueCancell')}},
              {click: this.saveTopologyNode, buttonModel: {content: this.$t('TS.ts_ok'), isPrimary: true}}
            ],
            title: `${this.$t('DeployManagement.nodeInfo')}`,
            isClose: true
          }
        },
        messages: {
          addDpNode: {
            title: `${this.$t('DeployManagement.nodeInfo')}`
          }
        }
      },
      headers: [
        { text: `${this.$t('DeployManagement.deployedInstance')}`, iconCss: 'tabsClass', key: 'service' },
        { text: `${this.$t('DeployManagement.deployedNode')}`, iconCss: 'tabsClass', key: 'node' },
      ],
      selectedItem: 0,
      qryParam: {
        envID: ''
      },
      envItem: '',
      deployedInstanceCount: '0',
      failedInstanceName: '0'
    }
  },
  methods: {
    initTable(target) {
      this.qryParam.envID = target.id;
      this.envItem = target;
      this.$refs.deployedServiceData.init(2);
      this.$refs.deployedNodeData.init(4);
    },
    buttonClk(param) {
      // this.$refs.deployedNodeData.$refs.grid.ej2Instances.dataSource
      if (param === 'add') {
        if(this.$refs.deployedNodeData.$refs.grid.ej2Instances.dataSource[0] === undefined){
          EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.canNotAddK8sNode') });
          return false;
        }else{
          this.$refs.addDPNodeDialog.setVersionValue(this.$refs.deployedNodeData.$refs.grid.ej2Instances.dataSource[0].displaySoftWareVersion);
          this.$refs.addDPNodePage.show();
        }
      } else if (param === 'edit') {
        const selectedRecord = this.getCheckedData(false);
        const params = {
          envID: this.qryParam.envID,
          dpId: selectedRecord[0].k8sNodeId
        };
        let pms = {}
        this.$axios.post('/lte/ems/deployed/getNodePms.html', params).then((res) => {
          if (res.data && res.data.resultVal) {
            pms = res.data.resultVal;
            this.$refs.addDPNodeDialog.setValue(selectedRecord[0], pms);
          }
        });
        this.$refs.addDPNodeDialog.setValue(selectedRecord[0], pms);
        this.$refs.addDPNodePage.show();
      } else if (param === 'del') {
        this.delDPNode();
      }
    },
    closeDPNodePage() {
      this.$refs.addDPNodePage.clear();
      this.$refs.addDPNodePage.close();
    },
    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.deployedNodeData.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.pleaseSelect') });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.pleaseSelectOne') });
        return false;
      }
      return selectedRecords;
    },
    delDPNode() {
      const selectedRecord = this.getCheckedData(false);
      if (selectedRecord && selectedRecord[0].service === 'MASTER') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.masterNotDel') });
        return false;
      }
      // console.log('selectedRecord: {}', selectedRecord)
      if (selectedRecord) {
        this.$layer.confirm({
          msg: this.$t('Topo.sureDel'),
          btn1: {
            msg: this.$t('Topo.cancel')
          },
          btn2: {
            msg: this.$t('Topo.confirm'),
            func: this.delDp
          }
        });
      }
    },
    delDp() {
      const selectedRecord = this.getCheckedData(false);
      const param = {
        dpId: selectedRecord[0].k8sNodeId
      };
      const url = '/lte/ems/deployed/shrinkK8sNode';
      this.$axios.post(url, param).then(res => {
        if (res.data.resultVal) {
          EventBus.$emit('toast', { type: 'success', content: this.$t('Track.success') });
          this.$refs.deployedNodeData.init(4);
        } else if (res.status !== 200) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        } else {
          EventBus.$emit('toast', { type: 'warning', content: res.data.errorString });
        }
      });
    },
    saveTopologyNode() {
      if (!this.$refs.addDPNodeDialog.validate()) return;
      const params = {
        info: {
          processName: 'ems_micropoc',
          type: this.envItem.type,
          ip: this.envItem.dpIp,
          port: this.envItem.dpPort,
          id: this.envItem.id
        },
        vo: this.$refs.addDPNodeDialog.getData()
      };
      this.$axios.post('/lte/ems/deployed/saveNodeAndDeploy.html', params).then((response) => {
        if (response && response.status === 200) {
          if (response.data.errorCode === '0') {
            this.closeDPNodePage();
            this.$refs.deployedNodeData.init(4);
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else {
            EventBus.$emit('toast', { type: 'error', content: this.$t('DeployManagement.addEnvironmentFailed') });
          }
        }
      });
    },
    deployedProgressInfo(result, envID, length, flag) {
      // this.deployedInstanceCount = result[this.qryParam.envID].deployedInstanceCount;
      // this.failedInstanceName = result[0].failedInstanceName;
      if (length !== 0 && flag === 1) { // 初始加载
        this.deployedInstanceCount = result[0].deployedInstanceCount;
        this.failedInstanceName = result[0].failedInstanceName;
      }
      if (length !== 0 && flag === 2) { // 循环查询
        let deployedNum = result[envID];
        if (deployedNum === null || deployedNum === undefined) {
          deployedNum = 0;
        }
        this.deployedInstanceCount = `${deployedNum}/${length}`;
        const params = {
          neId: result[(-2147483648 + envID)]
        };
        this.$axios.post('/lte/ems/deployed/queryNeElementById.html', params).then((response) => {
          if (response && response.status === 200) {
            if (response.data.errorCode === 'SUCCESS') {
              this.failedInstanceName = response.data.resultVal;
            }
          }
        });
      }
    }
  },
  components: {
    Table,
    AddDPNode,
    CustomDialog
  },
  created() {
    EventBus.$on('deployedProgressInfo', (target, envID, length, flag) => {
      this.deployedProgressInfo(target, envID, length, flag);
    });
  }
};
</script>
